<section *ngIf="data" #panelEl class="contact-panel">
  <div class="contact-panel__content">
    <div class="contact-panel__top">
      <h2 *ngIf="data.title?.value" #titleEl class="contact-panel__title">
        {{ data.title.value }}
      </h2>
    </div>

    <div *ngIf="data.contacts?.value" class="contact-panel__items">
      <app-contact-panel-item
        *ngFor="let item of data.contacts.value"
        [item]="item"
        [loadMedia]="loadMedia"
      ></app-contact-panel-item>
    </div>
  </div>
</section>
